import React from 'react';
import './Experience.css';
import { TbBrandSwift, TbBrandPython, TbBrandJavascript, TbDatabase } from 'react-icons/tb';
import { HiOutlineSparkles } from 'react-icons/hi';
import { LuBrainCircuit, LuCloud, LuTerminal, LuLayers, LuBot, LuGem, LuMessageSquare } from 'react-icons/lu';
import { SiSwift, SiOpenai, SiFirebase, SiSupabase, SiNodedotjs, SiPostgresql, SiGooglecloud } from 'react-icons/si';
import { FaApple, FaGitAlt, FaReact } from 'react-icons/fa';

const sections = [
  {
    title: 'Apple Platforms',
    subtitle: 'Where I ship',
    icon: <FaApple />,
    accent: 'apple',
    items: [
      { label: 'Swift / Swift 6', icon: <SiSwift /> },
      { label: 'SwiftUI', icon: <FaApple /> },
      { label: 'Foundation Models', icon: <HiOutlineSparkles /> },
      { label: 'Apple Intelligence', icon: <HiOutlineSparkles /> },
      { label: 'Core ML & Vision', icon: <LuBrainCircuit /> },
      { label: 'App Intents', icon: <FaApple /> },
      { label: 'SwiftData / CloudKit', icon: <LuLayers /> },
      { label: 'XcodeGen', icon: <TbBrandSwift /> },
    ],
  },
  {
    title: 'GenAI & Agents',
    subtitle: 'Daily exploration',
    icon: <HiOutlineSparkles />,
    accent: 'ai',
    items: [
      { label: 'Claude Code', icon: <LuBot /> },
      { label: 'Anthropic API', icon: <LuMessageSquare /> },
      { label: 'OpenAI API', icon: <SiOpenai /> },
      { label: 'Gemini API', icon: <LuGem /> },
      { label: 'Multi-Agent Systems', icon: <LuBrainCircuit /> },
      { label: 'Prompt Engineering', icon: <LuTerminal /> },
      { label: 'Harness Engineering', icon: <LuLayers /> },
      { label: 'Spec-Driven Dev', icon: <LuTerminal /> },
    ],
  },
  {
    title: 'Backend & Data',
    subtitle: 'POCs and APIs',
    icon: <TbDatabase />,
    accent: 'backend',
    items: [
      { label: 'Python', icon: <TbBrandPython /> },
      { label: 'JavaScript / TS', icon: <TbBrandJavascript /> },
      { label: 'Node.js', icon: <SiNodedotjs /> },
      { label: 'Supabase', icon: <SiSupabase /> },
      { label: 'Firebase', icon: <SiFirebase /> },
      { label: 'PostgreSQL', icon: <SiPostgresql /> },
      { label: 'Google Cloud', icon: <SiGooglecloud /> },
      { label: 'React', icon: <FaReact /> },
    ],
  },
  {
    title: 'Tooling',
    subtitle: 'Day to day',
    icon: <LuCloud />,
    accent: 'tools',
    items: [
      { label: 'Replit', icon: <LuTerminal /> },
      { label: 'Git', icon: <FaGitAlt /> },
      { label: 'Postman', icon: <LuTerminal /> },
      { label: 'TestRail', icon: <LuLayers /> },
      { label: 'Jira / Confluence', icon: <LuLayers /> },
      { label: 'Robot Framework', icon: <TbBrandPython /> },
      { label: 'Selenium', icon: <LuTerminal /> },
      { label: 'REST APIs', icon: <LuCloud /> },
    ],
  },
];

const Experience = () => {
  return (
    <section id="experience">
      <h5>Tech</h5>
      <h2>My stack</h2>

      <div className='container experience__container'>
        {sections.map(({ title, subtitle, icon, accent, items }) => (
          <div key={title} className={`experience__group experience__group--${accent}`}>
            <div className='experience__group-header'>
              <span className='experience__group-icon'>{icon}</span>
              <div>
                <h3>{title}</h3>
                <p>{subtitle}</p>
              </div>
            </div>

            <div className='experience__chips'>
              {items.map(({ label, icon: ItemIcon }) => (
                <span key={label} className='experience__chip'>
                  <span className='experience__chip-icon'>{ItemIcon}</span>
                  {label}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Experience;
